export const HomeTranslations = {
    homePageTranslations: {
        sections: {
            caregiverStories: {
                title: 'Historias de Cuidadores',
                description: 'Nuestros bloggers de cuidadores comparten sus historias sobre el cuidado de amigos y familiares y la vida después del cuidado.'
            }
        }
    }
}